import { useState } from "react";

export enum LoadState {
    None = "none",
    Loading = "loading",
    Loaded = "loaded",
    Error = "error"
}